import React from "react"
import classNames from "classnames"

const DriveModeButton = ({ onClick, isDriveMode }) => {
	const isMobile = window.innerWidth <= 768
	if (!isMobile) return null

	return (
		<div
			className={classNames("bg-blue text-white px-2 py-4 font-semibold text-center text-sm", {
				"drive-mode-active": isDriveMode,
			})}
			onClick={onClick}>
			{isDriveMode ? "Exit Drive Mode" : "Switch to Drive Mode"}
		</div>
	)
}

export default DriveModeButton
